<template>
  <a
    id="custom-img"
    class="display-flex btn btn-icon scale-28 p-0"
    :class="$route.path === '/chat' ? 'btn-primary' : 'btn-default'"
    href="/chat">
    <i
      class="mdi scale-20"
      :class="$route.path === '/chat' ? 'mdi-message-text' : 'mdi-message-text-outline'"
      aria-hidden="true" />
    <span
      v-if="showRedDotIcon() || showMessageIcon"
      class="img-circle topnav-notification-dot"
      aria-hidden="true" />
  </a>
</template>

<script>
import { mapState,mapActions, mapMutations } from 'vuex';

export default {
  name     : "MessengerIcon",
  computed : {
    ...mapState({
      conversations   : state => state.chatMessenger.conversations,
      announcements   : state => state.chatMessenger.announcements,
      showMessageIcon : state => state.chatMessenger.showRedDot
    }),
  },
  created(){
    this.getUnreadMessage()
  },
  methods : {
    ...mapActions("chatMessenger", ["getUnreadMessage"]),
    ...mapMutations({
      unshowRedDot : 'chatMessenger/GET_UNREAD_MESSAGE_LENGTH_SUCCESS',
    }),
    showRedDotIcon(){
      return Object.values(this.announcements).concat(Object.values(this.conversations)).some(({ UnreadMessages }) => {
        this.unshowRedDot(UnreadMessages.length >= 1)
        return UnreadMessages.length
      })
    }
  }
}
</script>
